<template>
  <div>
    <div v-show="false"> {{getResourcesListCounter}} </div>
    <div v-show="false"> {{getPartsListCounter}} </div>
    <div v-show="false"> {{getPermitsListCounter}} </div>
    <div v-show="false"> {{getTasksListCounter}} </div>
    <v-form v-model="valid" lazy-validation>
      <v-container :class="ui.bkgdColor">
        <v-layout row :class="ui.textSubheading">
          <div class="ml-4 mt-4 mb-4 mb-2">
            Work Execution Readiness
          </div>
        </v-layout>
        <div>
          <v-layout row wrap class="ml-0 mr-2 mt-3"
          v-if="this.getResourcesList.length === 0">
            <v-chip :color="ui.chipColor" :text-color="ui.textColor">
              <v-icon left :color="ui.btnColor"> person </v-icon>
              <div :class="ui.textSubheadingBold">
                <div>
                  Resources
                </div>
              </div>
            </v-chip>
            <v-spacer/>
            <v-chip :color="ui.chipColor" :text-color="ui.textColor">
              <v-icon left :color="ui.btnColor">check_box_outline_blank</v-icon>
              <div :class="ui.textSubheadingBold">
                U
              </div>
            </v-chip>
          </v-layout>
          <v-layout row wrap class="ml-0 mr-2 mt-3"
          v-if="this.getResourcesList.length > 0">
            <v-chip :color="ui.chipColor" :text-color="ui.textColor">
              <v-icon left :color="ui.btnColor"> person </v-icon>
              <div :class="ui.textSubheadingBold">
                <div>
                  Resources
                </div>
              </div>
            </v-chip>
            <v-spacer/>
            <v-chip
            v-if='this.calcStatsWorkStatus("Created", this.getResourcesList) > 0'
            :color="ui.chipColor"
            :text-color="ui.textColor"
            class="hidden-sm-and-down">
              <v-icon left :color="ui.btnColor">create</v-icon>
              <div :class="ui.textSubheadingBold">
                {{this.calcStatsWorkStatus("Created", this.getResourcesList)}}
              </div>
            </v-chip>
            <v-chip
            v-if='this.calcStatsWorkStatus("Order", this.getResourcesList) > 0'
            :color="ui.chipColor"
            :text-color="ui.textColor"
            class="hidden-sm-and-down">
              <v-icon left :color="ui.btnColor">shopping_bag</v-icon>
              <div :class="ui.textSubheadingBold">
                {{this.calcStatsWorkStatus("Order", this.getResourcesList)}}
              </div>
            </v-chip>
            <v-chip
            v-if='this.calcStatsWorkStatus("Progress", this.getResourcesList) > 0'
            :color="ui.chipColor"
            :text-color="ui.textColor"
            class="hidden-sm-and-down">
              <v-icon left :color="ui.btnColor">settings</v-icon>
              <div :class="ui.textSubheadingBold">
                {{this.calcStatsWorkStatus("Progress", this.getResourcesList)}}
              </div>
            </v-chip>
            <v-chip :color="ui.chipColor" :text-color="ui.colorWarning"
            v-if='this.calcStatsWorkStatus("Issue", this.getResourcesList) > 0'>
              <v-icon left :color="ui.colorWarning">warning</v-icon>
              <div :class="ui.textSubheadingBold">
                <div :class="ui.textColorWarning">
                  {{this.calcStatsWorkStatus("Issue", this.getResourcesList)}}
                </div>
              </div>
            </v-chip>
            <v-chip :color="ui.chipColor" :text-color="ui.textColor"
            v-if='this.calcStatsWorkStatus("Ready", this.getResourcesList) > 0'>
              <v-icon left :color="ui.btnColor">check_box</v-icon>
              <div :class="ui.textSubheadingBold">
                {{this.calcStatsWorkStatus("Ready", this.getResourcesList)}}
              </div>
            </v-chip>
          </v-layout>
        </div>
        <div>
          <v-layout row wrap class="ml-0 mr-2 mt-3"
          v-if="getPartsList.length === 0">
            <v-chip :color="ui.chipColor" :text-color="ui.textColor">
              <v-icon left :color="ui.btnColor"> category </v-icon>
              <div :class="ui.textSubheadingBold">
                <div>
                  Parts
                </div>
              </div>
            </v-chip>
            <v-spacer/>
            <v-chip :color="ui.chipColor" :text-color="ui.textColor">
              <v-icon left :color="ui.btnColor">check_box_outline_blank</v-icon>
              <div :class="ui.textSubheadingBold">
                U
              </div>
            </v-chip>
          </v-layout>
          <v-layout row wrap class="ml-0 mr-2 mt-3"
          v-if="getPartsList.length > 0">
            <v-chip :color="ui.chipColor" :text-color="ui.textColor">
              <v-icon left :color="ui.btnColor"> category </v-icon>
              <div :class="ui.textSubheadingBold">
                <div>
                  Parts
                </div>
              </div>
            </v-chip>
            <v-spacer/>
            <v-chip
            v-if='this.calcStatsWorkStatus("Created", this.getPartsList) > 0'
            :color="ui.chipColor"
            :text-color="ui.textColor"
            class="hidden-sm-and-down">
              <v-icon left :color="ui.btnColor">create</v-icon>
              <div :class="ui.textSubheadingBold">
                {{this.calcStatsWorkStatus("Created", this.getPartsList)}}
              </div>
            </v-chip>
            <v-chip
            v-if='this.calcStatsWorkStatus("Order", this.getPartsList) > 0'
            :color="ui.chipColor"
            :text-color="ui.textColor"
            class="hidden-sm-and-down">
              <v-icon left :color="ui.btnColor">shopping_bag</v-icon>
              <div :class="ui.textSubheadingBold">
                {{this.calcStatsWorkStatus("Order", this.getPartsList)}}
              </div>
            </v-chip>
            <v-chip
            v-if='this.calcStatsWorkStatus("Progress", this.getPartsList) > 0'
            :color="ui.chipColor"
            :text-color="ui.textColor"
            class="hidden-sm-and-down">
              <v-icon left :color="ui.btnColor">settings</v-icon>
              <div :class="ui.textSubheadingBold">
                {{this.calcStatsWorkStatus("Progress", this.getPartsList)}}
              </div>
            </v-chip>
            <v-chip :color="ui.chipColor" :text-color="ui.colorWarning"
            v-if="calcStatsWorkStatus('Issue', this.getPartsList) > 0">
              <v-icon left :color="ui.colorWarning">warning</v-icon>
              <div :class="ui.textSubheadingBold">
                <div :class="ui.textColorWarning">
                  {{this.calcStatsWorkStatus("Issue", this.getPartsList)}}
                </div>
              </div>
            </v-chip>
            <v-chip :color="ui.chipColor" :text-color="ui.textColor"
            v-if='this.calcStatsWorkStatus("Ready", this.getPartsList) > 0'>
              <v-icon left :color="ui.btnColor">check_box</v-icon>
              <div :class="ui.textSubheadingBold">
                {{this.calcStatsWorkStatus("Ready", this.getPartsList)}}
              </div>
            </v-chip>
          </v-layout>
        </div>
        <div>
          <v-layout row wrap class="ml-0 mr-2 mt-3"
          v-if="getPermitsList.length === 0">
            <v-chip :color="ui.chipColor" :text-color="ui.textColor">
              <v-icon left :color="ui.btnColor"> article </v-icon>
              <div :class="ui.textSubheadingBold">
                <div>
                  Permits
                </div>
              </div>
            </v-chip>
            <v-spacer/>
            <v-chip :color="ui.chipColor" :text-color="ui.textColor">
              <v-icon left :color="ui.btnColor">check_box_outline_blank</v-icon>
              <div :class="ui.textSubheadingBold">
                U
              </div>
            </v-chip>
          </v-layout>
          <v-layout row wrap class="ml-0 mr-2 mt-3"
          v-if="getPermitsList.length > 0">
            <v-chip :color="ui.chipColor" :text-color="ui.textColor">
              <v-icon left :color="ui.btnColor"> article </v-icon>
              <div :class="ui.textSubheadingBold">
                <div>
                  Permits
                </div>
              </div>
            </v-chip>
            <v-spacer/>
            <v-chip
            v-if='this.calcStatsWorkStatus("Created", this.getPermitsList) > 0'
            :color="ui.chipColor"
            :text-color="ui.textColor"
            class="hidden-sm-and-down">
              <v-icon left :color="ui.btnColor">create</v-icon>
              <div :class="ui.textSubheadingBold">
                {{this.calcStatsWorkStatus("Created", this.getPermitsList)}}
              </div>
            </v-chip>
            <v-chip :color="ui.chipColor" :text-color="ui.textColor"
            v-if='this.calcStatsWorkStatus("Progress", this.getPermitsList) > 0'
            class="hidden-sm-and-down">
              <v-icon left :color="ui.btnColor">settings</v-icon>
              <div :class="ui.textSubheadingBold">
                {{this.calcStatsWorkStatus("Progress", this.getPermitsList)}}
              </div>
            </v-chip>
            <v-chip :color="ui.chipColor" :text-color="ui.colorWarning"
            v-if="calcStatsWorkStatus('Issue', this.getPermitsList) > 0">
              <v-icon left :color="ui.colorWarning">warning</v-icon>
              <div :class="ui.textSubheadingBold">
                <div :class="ui.textColorWarning">
                  {{this.calcStatsWorkStatus("Issue", this.getPermitsList)}}
                </div>
              </div>
            </v-chip>
            <v-chip :color="ui.chipColor" :text-color="ui.textColor"
            v-if="calcStatsWorkStatus('Ready', this.getPermitsList) > 0">
              <v-icon left :color="ui.btnColor">check_box</v-icon>
              <div :class="ui.textSubheadingBold">
                {{this.calcStatsWorkStatus("Ready", this.getPermitsList)}}
              </div>
            </v-chip>
          </v-layout>
        </div>
        <div>
          <v-layout row wrap class="ml-0 mr-2 mt-3"
          v-if="getPermitsList.length === 0">
            <v-chip :color="ui.chipColor" :text-color="ui.textColor">
              <v-icon left :color="ui.btnColor"> functions </v-icon>
              <div :class="ui.textSubheadingBold">
                <div>
                  Total
                </div>
              </div>
            </v-chip>
            <v-spacer/>
            <v-chip :color="ui.chipColor" :text-color="ui.textColor">
              <v-icon left :color="ui.btnColor">check_box_outline_blank</v-icon>
              <div :class="ui.textSubheadingBold">
                U
              </div>
            </v-chip>
          </v-layout>
          <v-layout row wrap class="ml-0 mr-2 mt-3"
          v-if="getPermitsList.length > 0">
            <v-chip :color="ui.chipColor" :text-color="ui.textColor">
              <v-icon left :color="ui.btnColor"> bar_chart </v-icon>
              <div :class="ui.textSubheadingBold">
                <div>
                  Total
                </div>
              </div>
            </v-chip>
            <v-spacer/>
            <v-chip :color="ui.chipColor" :text-color="ui.textColor">
              <!-- <v-icon left :color="ui.btnColor">home</v-icon> -->
              <div :class="ui.textTitle2">
                {{counterTotal}}
              </div>
            </v-chip>
          </v-layout>
        </div>
        <div class="mt-4"/>
        <div class="mt-4"/>
        <div v-if="this.counterTotal > 0">
          <v-layout row :class="ui.textSubheading">
            <div class="ml-4 mt-4 mb-4 mb-2">
              Planning Progress
            </div>
          </v-layout>
          <v-layout class="ml-4 mr-4">
            <v-progress-linear
              height="3"
              :background-color="ui.colorBlue"
              :color="ui.colorSuccess"
              :value="this.calcProgressPlan()"
            ></v-progress-linear>
          </v-layout>
        </div>
        <div>
          <v-layout row wrap class="ml-0 mr-2 mt-3"
          v-if="getPermitsList.length > 0">
            <v-chip :color="ui.chipColor" :text-color="ui.textColor">
              <v-icon left :color="ui.btnColor"> bar_chart </v-icon>
              <div :class="ui.textSubheadingBold">
                <div>
                  Stats
                </div>
              </div>
            </v-chip>
            <v-spacer/>
            <v-chip :color="ui.chipColor" :text-color="ui.textColor">
              <v-icon left :color="ui.btnColor">more_time</v-icon>
              <div :class="ui.textSubheadingBold">
                {{calcProgressPlan()}}%
              </div>
            </v-chip>
          </v-layout>
        </div>
        <div>
          <v-layout row wrap class="ml-0 mr-2 mt-3"
          v-if="getPermitsList.length > 0">
            <v-chip :color="ui.chipColor" :text-color="ui.textColor">
              <v-icon left :color="ui.btnColor"> bubble_chart </v-icon>
              <div :class="ui.textSubheadingBold">
                <div>
                  Detail
                </div>
              </div>
            </v-chip>
            <v-spacer/>
            <v-chip :color="ui.chipColor" :text-color="ui.colorWarning"
            v-if="this.counterIssue > 0">
              <v-icon left :color="ui.colorWarning">warning</v-icon>
              <div :class="ui.textSubheadingBold">
                <div :class="ui.textColorWarning">
                  {{counterIssue}}
                </div>
              </div>
            </v-chip>
            <v-chip :color="ui.chipColor" :text-color="ui.textColor">
              <v-icon left :color="ui.btnColor">check_box</v-icon>
              <div :class="ui.textSubheadingBold">
                {{counterReady}}
              </div>
            </v-chip>
          </v-layout>
        </div>
        <div class="mt-4 mb-4">
          <v-layout row wrap class="ml-0 mr-2 mt-3">
            <v-chip :color="ui.chipColor" :text-color="ui.textColor">
              <v-icon left :color="ui.btnColor"> shopping_bag </v-icon>
              <div :class="ui.textSubheadingBold">
                <div>
                  Orders
                </div>
              </div>
            </v-chip>
            <v-spacer/>
            <v-chip :color="ui.chipColor" :text-color="ui.textColor"
            class="hidden-sm-and-down">
              <v-icon left :color="ui.btnColor">shopping_cart</v-icon>
              <div :class="ui.textSubheadingBold">
                {{counterOrder}}
              </div>
            </v-chip>
          </v-layout>
        </div>
        <v-layout row class="mt-4 mb-4"/>
        <div class="mt-4">
          <v-layout row class="mt-3 mr-3">
            <v-spacer/>
            <v-btn :color="readyBtn.color" flat outline
            v-if="true">
              <v-icon left> {{readyBtn.icon}} </v-icon>
              {{readyBtn.title}}
            </v-btn>
          </v-layout>
        </div>

        <!-- {{this.calcStatsWorkStatus("Issue", this.getPermitsList)}} -->

        <v-layout row class="mb-4">
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import apptheme from "@/frame/theme/mixins/apptheme.js";
import statsFunctions from "@/data/functions/mixins/statsFunctions.js";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      valid: true
    };
  },
  methods: {
    calcProgressPlan() {
      let per = 0;
      let completed = this.counterReady;
      let total = this.counterTotal;
      // eslint-disable-next-line
      per = completed / total;
      per = per * 100;
      per = per.toFixed(1);
      return per;
    }
  },
  mixins: [statsFunctions, apptheme],
  // components: {
  //   RoleDevelopmentManageCard,
  //   RoleDevelopmentSummaryCard
  // },
  computed: {
    ...mapGetters([
      "getResourcesList",
      "getPartsList",
      "getResourcesListCounter",
      "getPartsListCounter",
      "getPermitsList",
      "getPermitsListCounter",
      "getTasksList",
      "getTasksListCounter"
    ]),
    counterTotal() {
      let ctr = 0;
      let resources = this.getResourcesList.length;
      let parts = this.getPartsList.length;
      let permits = this.getPermitsList.length;
      ctr = resources + parts + permits;
      return ctr;
    },
    counterReady() {
      let ctr = 0;
      let resources = this.calcStatsWorkStatus("Ready", this.getResourcesList);
      let parts = this.calcStatsWorkStatus("Ready", this.getPartsList);
      let permits = this.calcStatsWorkStatus("Ready", this.getPermitsList);
      ctr = resources + parts + permits;
      return ctr;
    },
    counterIssue() {
      let ctr = 0;
      let resources = this.calcStatsWorkStatus("Issue", this.getResourcesList);
      let parts = this.calcStatsWorkStatus("Issue", this.getPartsList);
      let permits = this.calcStatsWorkStatus("Issue", this.getPermitsList);
      ctr = resources + parts + permits;
      return ctr;
    },
    counterOrder() {
      let ctr = 0;
      let resources = this.calcStatsWorkStatus("Order", this.getResourcesList);
      let parts = this.calcStatsWorkStatus("Order", this.getPartsList);
      let permits = this.calcStatsWorkStatus("Order", this.getPermitsList);
      ctr = resources + parts + permits;
      return ctr;
    },
    readyBtn() {
      let btn = {
        title: "",
        icon: "",
        color: ""
      };
      // define conters
      let c = 0; // created
      c = this.calcStatsWorkStatus("Created", this.getResourcesList);
      c = c + this.calcStatsWorkStatus("Created", this.getPartsList);
      c = c + this.calcStatsWorkStatus("Created", this.getPermitsList);
      let p = 0; // progress
      p = this.calcStatsWorkStatus("Order", this.getResourcesList);
      p = p + this.calcStatsWorkStatus("Order", this.getPartsList);
      p = p + this.calcStatsWorkStatus("Progress", this.getPermitsList);
      let i = 0; // issue
      i = this.calcStatsWorkStatus("Issue", this.getResourcesList);
      i = i + this.calcStatsWorkStatus("Issue", this.getPartsList);
      i = i + this.calcStatsWorkStatus("Issue", this.getPermitsList);
      i = i + this.calcStatsWorkStatus("Issue", this.getTasksList);
      let r = 0; // issue
      r = this.calcStatsWorkStatus("Ready", this.getResourcesList);
      r = r + this.calcStatsWorkStatus("Ready", this.getPartsList);
      r = r + this.calcStatsWorkStatus("Ready", this.getPermitsList);

      // check
      if (c == 0 && p == 0 && i == 0 && r == 0) {
        btn.title = "Define Requirements";
        btn.icon = "create";
        btn.color = this.ui.colorWarning;
      } else if (c > 0) {
        btn.title = "Work Resourcing";
        btn.icon = "create";
        btn.color = this.ui.btnColor;
      } else if (p > 0) {
        btn.title = "Work Planning";
        btn.icon = "settings";
        btn.color = this.ui.btnColor;
      } else if (i > 0) {
        btn.title = "Work Issue";
        btn.icon = "warning";
        btn.color = this.ui.colorWarning;
      } else if (r > 0) {
        btn.title = "Work Ready";
        btn.icon = "create";
        btn.color = this.ui.colorSuccess;
      } else {
        btn.title = "Undefined";
        btn.icon = "check_box_outline_blank";
        btn.color = this.ui.btnColor;
      }
      // return btn
      return btn;
    }
  }
};
</script>
